
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import item from './resumen-item.vue';
    import { Wait } from '@/__env/ext';
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item
        }
    } )
    export default class Componente extends Vue
    {
        @Prop() public Controlador: ControladorSeccion;
        public get Altura() { return this.Controlador.Vista.BarraArriba.Altura.Espacio; }
        public set Altura( x: number ) { this.Controlador.Vista.BarraArriba.Altura.Espacio = x; }
        public get Abierto() { return this.Controlador.Vista.BarraArriba.Abierto; }
        public set Abierto( x: boolean ) { this.Controlador.Vista.BarraArriba.Abierto = x; }
        public get Valores() { return this.Controlador.Estadistica.Valores; }
        public get Estadistica() { return this.Controlador.Estadistica.Estadistica; }
        public get EstadoSeleccionado() { return this.Controlador.Estadistica.EstadoSeleccionado; }
        public Cargando: boolean = true;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraArriba.onAbierto.subscribe( () => { this.Alternar(); } ) );
            this.Eventos.push( this.Controlador.Buscador.onActualizar.subscribe( () => { this.Iniciar(); } ) );
            this.Eventos.push( this.Controlador.onRecargarEstadistica.subscribe( () => { this.Iniciar( true ); } ) );
            await this.Iniciar();
            this.Controlador.Vista.BarraArriba.Abierto = true;
        }

        async Iniciar( forzar: boolean = false )
        {
            this.Cargando = true;
            await this.Controlador.Estadistica.Iniciar( forzar );
            this.Cargando = false;

        }

        AlternarManual()
        {
            this.Abierto = !this.Abierto;
            this.Controlador.Vista.BarraArriba.AbiertoManual = this.Abierto;
        }
        Alternar()
        {
            console.log( this.Abierto );
            console.log( this.Controlador.Vista.BarraArriba.Abierto );
            if ( this.Abierto )
                this.Altura = 195;
            else
                this.Altura = 30;
        }
    }
